export default {
	start: {
		title: "AI platforma",
		tips: "Zarábajte skrolovaním! Denne výber jedným klikom – Váš telefón je stroj na peniaze!"
	},
	login: {
		tips: "Nemáte účet?",
		Signup: "Zaregistrovať sa",
		logIn: "Prihlásiť sa",
		Remember: "Zapamätať si ma",
		form: {
			label: ["Používateľské meno/Telefón", "Heslo"]
		},
		forgotPassword: "Zabudli ste heslo?",
		contactSupport: "Kontaktujte podporu",
		title: "Vytvoriť účet",
		content: ["Potrebujete účet?", "Vytvorte si ho tu"]
	},
	register: {
		form: {
			label: [
				"Používateľské meno",
				"Telefón",
				"Obchodné heslo",
				"Prihlasovacie heslo",
				"Potvrďte prihlasovacie heslo",
				"Pohlavie",
				"Pozývací kód",
				"E-mail",
				"Overovací kód"
			],
			rule: {
				Username: "Používateľské meno musí mať 4–10 znakov",
				Email: "Zadajte platný e-mail",
				Phone: "Telefónne číslo musí mať aspoň 4 číslice",
				ConfirmLoginPassword: "Heslá sa nezhodujú",
				TradingPassword: "Obchodné heslo musí mať aspoň 6 znakov",
				LoginPassword: "Prihlasovacie heslo musí mať aspoň 6 znakov"
			}
		},
		sendMsg: "Kód odoslaný! Skontrolujte správu.",
		agree: ["Súhlasím s {0}", "Zásadami ochrany osobných údajov, MSA", "a", "Podmienkami používania"],
		content: [
			"Vytvoriť bezplatný účet",
			"Už máte účet?",
			"Prihlásiť sa tu",
			"Vytvoriť účet",
			"Pokračovaním súhlasíte s našimi"
		]
	}
};
